/**
 * Shows only the selected colour's photos in the product gallery.
 * Liquid tags each gallery item with data-k-group (the main photo ID of the colour it belongs to,
 * or "all" for photos placed before the first colour photo). This keeps the gallery in sync when
 * the shopper picks another variant.
 */
const gallery = document.querySelector('[data-product-gallery][data-k-variant-groups]');
const mapEl = document.querySelector('[data-k-variant-media]');

if (gallery && mapEl) {
  let variantMedia = {};
  try {
    variantMedia = JSON.parse(mapEl.textContent);
  } catch (error) {
    console.error('[k-variant-gallery] Could not read variant photos', error);
  }

  let lastVariant = null;

  const currentVariantId = () => {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return (input && input.value) || new URL(location.href).searchParams.get('variant');
  };

  const apply = () => {
    const variantId = currentVariantId();
    if (!variantId || variantId === lastVariant) return;
    lastVariant = variantId;
    const group = variantMedia[variantId];
    gallery.querySelectorAll('[data-k-group]').forEach((item) => {
      const itemGroup = item.dataset.kGroup;
      item.hidden = Boolean(group) && itemGroup !== 'all' && itemGroup !== group;
    });
    gallery.scrollTo({ left: 0, behavior: 'instant' });
  };

  const schedule = () => requestAnimationFrame(apply);
  document.addEventListener('change', schedule);
  window.addEventListener('popstate', schedule);
  const info = gallery.closest('.product-grid') || document.body;
  new MutationObserver(schedule).observe(info, { subtree: true, childList: true });
  apply();
}
